export default __webpack_public_path__ + "static/media/4.3a02cc65.png";